module.exports = __webpack_public_path__ + "static/img/g_1_tick.a6132951.png";